import { db } from "./db";

const ClearUser = async () => {
  let user = localStorage.removeItem("LogedUser");

  await db.menu.clear();
};
export default ClearUser;
